import { Component } from '@angular/core';
import { CONFIG } from '../../helper/app-config';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, SubscriptionLike } from 'rxjs';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { UserSupportPopUpComponent } from '../user-support-pop-up/user-support-pop-up.component';
import { MatDialog } from '@angular/material/dialog';
import * as path from 'path';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css',
})
export class LandingPageComponent {
  saved_planogram_landing_page_info_data_observer: Observable<any> =
    this.planogramState.saved_planogram_landing_page_info_data;
  saved_planogram_landing_page_info_data_subscription: SubscriptionLike;
  user_info_observable: Observable<any> = this.planogramState.userInfo;
  user_info_subscription: SubscriptionLike;
  created_planograms: number = 0;
  possible_planograms: number = 0;
  is_show_loader = false;
  loader: Observable<boolean> = this.planogramState.loader;
  admin_flag: string;
  user_info_data: any;
  user_type: any;

  constructor(
    private router: Router,
    private planogramState: PlanogramStateService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    const user_id = localStorage.getItem('user_id');
    this.admin_flag = localStorage.getItem('admin_flag') || '0';
    this.planogramState.getUserInfo();

    this.user_info_subscription = this.user_info_observable.subscribe((res) => {
      this.user_info_data = res;
      this.user_type=res.display_name
      //  let userTypePresent=localStorage.getItem("user_type")
      //  if(userTypePresent && this.admin_flag=='1'){
      //   this.user_type= userTypePresent
      //  }
      //  else{
      //   this.user_type=res.display_name
      //  }
      if (this.user_info_data && res.display_name && res.display_name !== 'Admin') {
        this.planogramState.getSavedPlanogramData({});
        this.saved_planogram_landing_page_info_data_subscription =
          this.saved_planogram_landing_page_info_data_observer.subscribe(
            (res) => {
              this.created_planograms = res.created_planograms;
              this.possible_planograms = res.possible_planograms;
            }
          );
      }
      console.log('user info', this.user_info_data);
    });
  }

  addNewPlanogram() {
    this.router.navigateByUrl(CONFIG.PATH.NEWPLANOGRAM);
  }

  moveToAdminGuidelinesUpdate() {
    this.router.navigateByUrl(CONFIG.PATH.ADMIN_UPDATE_GUIDELINES);
  }

  moveToPlanogramLibrary() {
    const state = {
      screen_index: 0,
      screen: 'planogram-list',
      path: CONFIG.PATH.PLANOGRAMS,
    };
    this.router.navigateByUrl(CONFIG.PATH.PLANOGRAMS, { state });
  }

  moveToDataSetUpdateScreen() {
    this.router.navigateByUrl(CONFIG.PATH.ADMIN_DATA_UPDATE);
  }

  moveToUserAnalyticsScreen() {
    this.router.navigateByUrl(CONFIG.PATH.ADMIN_USER_ANALYTICS);
  }
  openUserSupportDialog() {
    this.dialog.open(UserSupportPopUpComponent, {
      height: '70vh',
      width: '55vw',
      maxWidth: '55vw',
      data: {},
    });
  }

  userAdminInterChange(type: string) {
    this.user_type = type;
    localStorage.setItem('user_type', this.user_type);
  }

  moveToCustomPlanogramScreen() {
    this.router.navigateByUrl(CONFIG.PATH.ADMIN_CUSTOM_PLANOGRAM_NEW);
  }
}
